export class OnboardingProgressDetailsDto {
  progressPercent: number;
  invitationSent: boolean;
  firstAccessCompleted: boolean;
  formCompleted: boolean;
  completedUploadRequirements: number;
  totalUploadRequirements: number;
  completedSignatureRequirements: number;
  totalSignatureRequirements: number;
  completedUploadCategoryIds: string[];
  requiredUploadsCompleted: boolean;
  requiredSignaturesCompleted: boolean;
  canSubmit: boolean;
}
